/* global messg */
import './styles.scss'

import I18n from 'lib/i18n'
import React, { useEffect, useRef } from 'react'
import { useActions, useValues } from 'kea'
import NProgress from 'nprogress'
import Dropzone from 'dropzone'

import Textarea from 'lib/forms/textarea-autosize'
import SubmitButton from 'lib/tags/submit-button'
import Attachments from 'lib/components/attachments'
import attachSvg from 'lib/components/attachments/attach.svg'

import logic from './logic'
import Name from './fields/name'
import Email from './fields/email'
import Phone from './fields/phone'
import Question from './fields/question'
import UserSelect from './fields/user-select'

const accept = ['image/jpeg', 'image/jpg', 'image/gif', 'image/png', 'application/pdf'].join(',')
const uploadUrl = '/inbox/add_attachment'

const questionsArray = ['booking', 'profile', 'account', 'press', 'bug', 'other']
const questions = questionsArray.map(key => ({ id: key, name: I18n.t(`pages.contact.question_${key}`) }))
const questionTypes = [{ id: '', name: '-' }, ...questions]

const ContactForm = () => {
  const {
    askForName,
    attachments,
    canAttach,
    email,
    errors,
    hasErrors,
    isSubmitting,
    message,
    name,
    phone,
    question,
    sessionCountry,
    user,
    users
  } = useValues(logic)

  const { handleUploadFile, removeAttachment, setEmail, setMessage, setName, setPhone, setQuestion, setUser, submit } =
    useActions(logic)

  const contactDropzoneRef = useRef(null)

  useEffect(() => {
    if (contactDropzoneRef.current) {
      const csrfMetaToken = document.querySelector('meta[name=csrf-token]')

      const options = {
        url: uploadUrl,
        acceptedFiles: accept,
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': csrfMetaToken && csrfMetaToken.content
        },
        autoProcessQueue: true,
        disablePreviews: true,
        parallelUploads: 5,
        maxFilesize: 5,
        clickable: ['#attach-link'],
        init: function () {
          let totalBytesSent = 0
          let totalBytes = 0

          this.on('addedfile', file => {
            if (!this.options.acceptedFiles.includes(file.type)) {
              this.removeFile(file)
            } else {
              totalBytes += file.size
              NProgress.set(0.0)
            }
          })

          this.on('uploadprogress', function (file, _progress, bytesSent) {
            totalBytesSent += bytesSent - file.upload.bytesSent
            file.upload.bytesSent = bytesSent

            const totalProgress = (totalBytesSent / totalBytes) * 100
            NProgress.set(totalProgress / 100)
          })
          this.on('success', (_file, response) => {
            handleUploadFile(response)
          })
          this.on('complete', _file => {
            this.removeAllFiles(true)
          })
          this.on('error', (_file, _errorMessage) => {
            messg.error(I18n.t('activerecord.errors.models.user.attributes.avatar_custom.wrong_type'), 4000)
          })
          this.on('queuecomplete', () => {
            NProgress.set(1.0)
          })
        }
      }

      contactDropzoneRef.current.dropzoneInstance = new Dropzone(contactDropzoneRef.current, options)
    }
  }, [handleUploadFile])

  const widget = (
    <div>
      <h4>{I18n.t('pages.contact.info')}</h4>

      {askForName && (
        <>
          <Name errors={errors} name={name} onChange={setName} />
          <Email errors={errors} email={email} onChange={setEmail} />
          <Phone errors={errors} phone={phone} onChange={setPhone} sessionCountry={sessionCountry} />
        </>
      )}

      <Question errors={errors} question={question} questionTypes={questionTypes} onChange={setQuestion} />

      {users && users.length > 0 ? <UserSelect errors={errors} user={user} users={users} onChange={setUser} /> : null}

      <div className={`form-element large ${errors.message ? 'has-errors' : ''}`}>
        <label className='block'>{I18n.t('pages.contact.message')}</label>
        <Textarea
          value={message}
          placeholder={I18n.t('pages.contact.message_placeholder')}
          onValueChange={setMessage}
        />
        {errors.message ? <div className='simple-error'>{errors.message}</div> : null}
      </div>

      {canAttach && (
        <div className='attach-files'>
          <Attachments attachments={attachments} removeAttachment={removeAttachment} custom='white' />
          <div className='attach-link-row'>
            <img src={attachSvg} width={24} height={24} alt='attach link' />
            <span className='attach-link' id='attach-link'>
              {I18n.t('messages.show_thread.attachment_add')}
            </span>
          </div>
        </div>
      )}

      <SubmitButton isSubmitting={isSubmitting} isButtonHaveDisabledStyle={hasErrors} onClick={submit}>
        {I18n.t('pages.contact.submit')}
      </SubmitButton>
    </div>
  )

  return (
    <div className='row'>
      <div className='twelve columns'>
        <h1 className='page-title'>{I18n.t('pages.contact.contact')}</h1>

        {canAttach ? (
          <div ref={contactDropzoneRef} id='contact-attachments' className='widget space droppable'>
            {widget}
          </div>
        ) : (
          <div className='widget space'>{widget}</div>
        )}
      </div>
    </div>
  )
}
export default ContactForm
